<template>
  <div class="pluck-loading">
    <ba-loading :absolutePosition="false" />
    <p class="title"
       v-html="$t('journey.pluck.checkingData.title')"></p>

    <div class="loading--wrap">
      <i class='loading-bar'></i>
      <i class='loading-bar'></i>
      <i class='loading-bar'></i>
      <i class='loading-bar'></i>
      <i class='loading-bar'></i>
    </div>

    <p class="desc"
       v-html="$t('journey.pluck.checkingData.description')">
    </p>

    <ui-button class="btn-cancel"
               :buttonType="'reset'"
               @click="$emit('onCancel')">
      {{ $t('common.cancel') }}
    </ui-button>
  </div>
</template>

<script>
import UiButton from '@/components/ui/UiButton'
import BaLoading from '@/components/ui/ba/Loading'

export default {
  name: 'PluckLoading',
  components: {
    UiButton,
    BaLoading
  }
}
</script>

<style lang="scss" scoped>
.pluck-loading {
  text-align: center;
  padding-top: 23px;

  .ba-loading {
    margin: 20px 0 10px;
  }

  .title {
    font-size: 20px;
    color: #444444;
  }

  .loading--wrap {
    width: 180px;
    height: 12px;
    margin: 14px auto;

    .loading-bar {
      display: block;
      position: absolute;
      padding: 6px;
      border-radius: 50%;
      background-color: $brandColor;
      animation: loading 1.4s ease-in-out 0s infinite;

      &:nth-child(1) {
        animation-delay: 0s;
      }

      &:nth-child(2) {
        animation-delay: 0.15s;
      }

      &:nth-child(3) {
        animation-delay: 0.3s;
      }

      &:nth-child(4) {
        animation-delay: 0.45s;
      }

      &:nth-child(5) {
        animation-delay: 0.6s;
      }
    }
  }

  .desc {
    margin-top: 20px;
    font-size: 14px;
    line-height: 1.5;
    color: #444444;
  }

  .btn-cancel {
    margin-top: 24px;
    width: 90px;
  }
}

@keyframes loading {
  0% {
    transform: translateX(-15px);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(180px);
    opacity: 0;
  }
}
</style>
